var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckoutTime = function SvgIconCheckoutTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.71,
    height: 36.713,
    viewBox: "0 0 36.71 36.713",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(-721.73 -528.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-243.661 298.618)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 17.705,
    cy: 17.706,
    rx: 17.705,
    ry: 17.706,
    transform: "translate(966.042 230.05)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(983.496 238.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.074,11.364,0,0",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 12.266,
    transform: "translate(0 10.658)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    y2: 2.942,
    transform: "translate(983.748 230.05)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y2: 2.915,
    transform: "translate(983.748 262.42)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 2.958,
    transform: "translate(966.042 247.756)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 3.123,
    transform: "translate(998.425 247.756)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckoutTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_checkout_time.e317e2e2.svg";
export { ForwardRef as ReactComponent };